import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Router } from '@angular/router';

import { of } from 'rxjs';
import { filter, tap, switchMap } from 'rxjs/operators';

import { CoreModule } from '../core';
import { SharedModule } from '../shared';
import { UIModule } from '../ui.module';

import { FeaturesService } from '../features.service';
import { VersionService } from '../version.service';

import { SeasonWorldLandingRoutingModule } from './season-world-landing.routing';
import { SeasonWorldLandingComponent } from './season-world-landing.component';
import { ShowSeasonWorldLandingService } from './show-season-world-landing.service';

@NgModule({
    imports: [
        CommonModule,
        NoopAnimationsModule,
        RouterModule,

        CoreModule,
        SharedModule,
        UIModule,
        SeasonWorldLandingRoutingModule
    ],
    declarations: [
        SeasonWorldLandingComponent
    ],
    providers: [
        ShowSeasonWorldLandingService
    ]
})
export class SeasonWorldLandingModule {
    constructor(
        private _router: Router,
        private _versionSrv: VersionService,
        private _featuresSrv: FeaturesService,
        private _seasonWorldLanding: ShowSeasonWorldLandingService
    ) {
        this.init()
    }

    async init() {
        const checkRoute$ = this._router.events.pipe(filter(({ url }: any) => url && url != '/nw-menu'));

        this._versionSrv.afterUpgrade$.subscribe(() => {
            (!!window.nw ? checkRoute$ : of(true))
                .pipe(switchMap(() => this._featuresSrv.data$))
                .pipe(filter((features) => !!features['persistent-world']))
                .pipe(filter(() => this._seasonWorldLanding.available()))
                .pipe(tap(() => this._seasonWorldLanding.show()))
                .subscribe();
        });
    }
}
